import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { translations } from './translations';

const LanguageContext = createContext(null);

const STORAGE_KEY = 'tl_lang';

function getInitialLang() {
  if (typeof window === 'undefined') return 'nl';
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'nl' || stored === 'en') return stored;
  } catch {
    // ignore
  }
  return 'nl';
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(getInitialLang);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
      document.documentElement.lang = lang;
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    if (next === 'nl' || next === 'en') setLangState(next);
  }, []);

  const dict = translations[lang] || translations.nl;

  // Resolve dot-path key like "nav.home"; falls back to NL, then to the key itself
  const t = useCallback(
    (path) => {
      const get = (obj) =>
        path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);
      const val = get(dict);
      if (val !== undefined) return val;
      const fb = get(translations.nl);
      return fb !== undefined ? fb : path;
    },
    [dict]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLang must be used within LanguageProvider');
  }
  return ctx;
}
